import styled, { css } from 'styled-components'
import { backgroundBlur } from 'styles/backgroundBlur'
import {
  PHONE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from '../../../styles/breakpoints'
import _isNumber from 'lodash-es/isNumber'

export const ModalWrapper = styled.div<{
  width?: number
  fit?: boolean
  noPadding?: boolean
  maxWidth?: number
  isFullscreen?: boolean
}>`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ isFullscreen }) => (isFullscreen ? '0' : '35px')};
  @media screen and (max-width: ${PHONE_BREAKPOINT}px) {
    min-width: 100%;
    max-height: 100%;
  }
  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    padding: ${({ isFullscreen }) => (isFullscreen ? '0' : '10px')};
  }
`

export const ModalContent = styled.div<{
  fitContent?: boolean
  size?: any
  isFullscreen?: boolean
  minWidth?: string | number
  maxWidth?: string | number
}>`
  display: flex;
  flex-direction: column;
  min-width: ${({ minWidth }) =>
    _isNumber(minWidth) ? minWidth + 'px' : minWidth};
  width: ${({ isFullscreen }) => (isFullscreen ? '100vw' : '100%')};
  height: ${({ isFullscreen }) => (isFullscreen ? '100vh' : 'fit-content')};
  max-height: ${({ isFullscreen }) => (isFullscreen ? '100vh' : '100%')};
  border-radius: ${({ isFullscreen }) => (isFullscreen ? 'none' : '5px')};
  border: 1px solid ${({ theme }) => theme.border};
  max-width: ${({ size, fitContent, isFullscreen, maxWidth }) => {
    if (isFullscreen) return '100vw'
    if (maxWidth) return _isNumber(maxWidth) ? maxWidth + 'px' : maxWidth
    if (fitContent) return 'fit-content'
    if (size === 'lg') return '1000px'
    return '780px'
  }};
  ${backgroundBlur};

  :last-of-type {
    margin-bottom: 0px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export const ModalBody = styled.div<{
  noPadding?: boolean
  fitContent?: boolean
  isFullscreen?: boolean
}>`
  padding: ${({ noPadding }) => (noPadding ? '10px' : '30px')};
  flex: 1;
  overflow-y: ${({ fitContent }) => (fitContent ? 'hidden' : 'scroll')};
  background-color: ${({ theme }) => theme.background.secondary};

  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
  scrollbar-color: transparent transparent;
  :hover {
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.border};
    }
    scrollbar-color: ${({ theme }) => theme.border} transparent;
  }
  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.border};
    }
    scrollbar-color: ${({ theme }) => theme.border} transparent;
  }

  // For IOS devices only
  @supports (-webkit-touch-callout: none) {
    padding-bottom: 60px;
  }
`
